import type { ComponentProps, FC } from "react";

import { cn } from "@/lib/utils";

/**
 * Small uppercase meta text (counts, dates, group labels), sized for app
 * chrome. Uses the app sans face with wide tracking and tabular numerals — no
 * monospace typeface on these screens. Use for machine-ish values, not prose.
 */
export const MetaLabel: FC<ComponentProps<"span">> = ({
  className,
  ...props
}) => (
  <span
    {...props}
    className={cn(
      "text-xs uppercase tracking-wider text-muted-foreground tabular-nums",
      className
    )}
  />
);
